module.exports = __webpack_public_path__ + "static/img/banner.f6a0ab5.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/banner.png
// module id = 6h6E
// module chunks = 1